export default __webpack_public_path__ + "static/media/5.0899b3b8.svg";